import {
  SEAT_BOOKING_GET_DATA,
  SEAT_BOOKING_DATA,
  SEAT_BOOKING_ADD_DATA,
  SEAT_BOOKING_CANCEL_DATA,
  MY_BOOKING_GET_DATA,
  SEAT_BOOKING_TIMESLOT_DATA,
} from "./Constants";

const initialState = {
  loading: false,
  error: null,
  avaibleseats: [],
  seats: [],
  seatBooking: null,
  seatBookingSuccess: false,
  cancelBooking: null,
  cancelBookingSuccess: false,
  mybookings: [],
  slots: [],
};

const Reducer = (state = initialState, action) => {
  switch (action.type) {

    /* ================= AVAILABLE SEATS ================= */

    case SEAT_BOOKING_GET_DATA.SEAT_BOOKING_GET_DATA_LOAD:
      return {
        ...state,
        loading: true,
        error: null,
        avaibleseats: [],
      };

    case SEAT_BOOKING_GET_DATA.SEAT_BOOKING_GET_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        avaibleseats: action.avaibleseats,
        error: null,
      };

    case SEAT_BOOKING_GET_DATA.SEAT_BOOKING_GET_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        avaibleseats: [],
      };

    /* ================= LISTING ================= */

    case SEAT_BOOKING_DATA.SEAT_BOOKING_DATA_LOAD:
      return {
        ...state,
        loading: true,
        error: null,
        seats: [],
      };

    case SEAT_BOOKING_DATA.SEAT_BOOKING_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        seats: action.seats,
        error: null,
      };

    case SEAT_BOOKING_DATA.SEAT_BOOKING_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        seats: [],
      };

    /* ================= ADD SEAT BOOKING ================= */

    case SEAT_BOOKING_ADD_DATA.SEAT_BOOKING_ADD_DATA_LOAD:
      return {
        ...state,
        loading: true,
        error: null,
        seatBooking: null,
        seatBookingSuccess: false,
      };

    case SEAT_BOOKING_ADD_DATA.SEAT_BOOKING_ADD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        seatBooking: action.response,
        error: null,
        seatBookingSuccess: true,
      };

    case SEAT_BOOKING_ADD_DATA.SEAT_BOOKING_ADD_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        seatBooking: null,
        seatBookingSuccess: false,
      };

    /* ================= CANCEL SEAT BOOKING ================= */

    case SEAT_BOOKING_CANCEL_DATA.SEAT_BOOKING_CANCEL_DATA_LOAD:
      return {
        ...state,
        loading: true,
        error: null,
        cancelBooking: null,
        cancelBookingSuccess: false,
      };

    case SEAT_BOOKING_CANCEL_DATA.SEAT_BOOKING_CANCEL_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        cancelBooking: action.response,
        error: null,
        cancelBookingSuccess: true,
      };

    case SEAT_BOOKING_CANCEL_DATA.SEAT_BOOKING_CANCEL_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        cancelBooking: null,
        cancelBookingSuccess: false,
      };
    
    /* ================= MY SEATS ================= */

    case MY_BOOKING_GET_DATA.MY_BOOKING_GET_DATA_LOAD:
      return {
        ...state,
        loading: true,
        error: null,
        mybookings: [],
      };

    case MY_BOOKING_GET_DATA.MY_BOOKING_GET_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        mybookings: action.mybookings,
        error: null,
      };

    case MY_BOOKING_GET_DATA.MY_BOOKING_GET_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        mybookings: [],
      };  

    /* ================= LISTING ================= */

    case SEAT_BOOKING_TIMESLOT_DATA.SEAT_BOOKING_TIMESLOT_DATA_LOAD:
      return {
        ...state,
        loading: true,
        error: null,
        slots: [],
      };

    case SEAT_BOOKING_TIMESLOT_DATA.SEAT_BOOKING_TIMESLOT_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        slots: action.slots,
        error: null,
      };

    case SEAT_BOOKING_TIMESLOT_DATA.SEAT_BOOKING_TIMESLOT_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        slots: [],
      };  

    default:
      return {
        ...state,
      };
  }
};

export default Reducer;
